import { useParams, useSearch } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { OfferRequestDetailPage } from './OfferRequestDetailPage';

export function OfferRequestDetailRoute(): ReactElement {
    const { offerRequestLeadUuid } = useParams({ strict: false });
    const isContactScreenOpen = useSearch({ strict: false, select: (search) => search.contact === true });
    return (
        <OfferRequestDetailPage
            offerRequestLeadUuid={offerRequestLeadUuid ?? ''}
            isContactScreenOpen={isContactScreenOpen}
        />
    );
}
